import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['assignments'];

  showAssignments() {
    $(this.assignmentsTarget).show('fast');
  }

  hideAssignments() {
    $(this.assignmentsTarget).hide('fast');
  }
}
